// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a single purchase order by its nano-id key.
 */
export async function getPurchaseOrderAuditEvents(purchaseOrderKey: string) {
  const url = `/v1/purchase-order/${purchaseOrderKey}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'PurchaseOrderAuditEvents',
    endpoint: url,
  });
}
